<template>
  <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onSubmit)">
      <div class="rounded-lg bg-smoke-100 py-4 px-2 lg:px-4 md:py-7.5 md:px-12 xl:px-56">
        <div class="flex border-b border-dark-b">
          <h2 class="text-xl md:text-2xl lg:font-bold font-semibold">
            Company Details
          </h2>
        </div>
        <div class="flex flex-wrap w-full pt-9 lg:pt-12">
          <div class="lg:pr-5 w-full lg:w-1/2">
            <div class="lg:pb-1 font-semibold text-lg lg:text-xl">
              First Name<span class="text-red-600">*</span>
            </div>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <input
                name="firstName"
                class="form-input"
                placeholder="e.g. John"
                v-model="formData.first_name"
              />
              <div class="input-error --end">
                <span v-if="errors[0]">This field is required</span>
              </div>
            </ValidationProvider>
          </div>
          <div class="lg:pl-5 w-full lg:w-1/2">
            <div class="lg:pb-1 font-semibold text-lg lg:text-xl">
              Last Name<span class="text-red-600">*</span>
            </div>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <input
                name="lastName"
                class="form-input"
                placeholder="e.g. Doe"
                v-model="formData.last_name"
              />
              <div class="input-error --end">
                <span v-if="errors[0]">This field is required</span>
              </div>
            </ValidationProvider>
          </div>     
        </div>
          <div class="flex flex-wrap w-full">
          <div class="lg:pr-5 w-full lg:w-1/2">
            <div class="lg:pb-1 font-semibold text-lg lg:text-xl">
              Company Name<span class="text-red-600">*</span>
            </div>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <input
                name="companyName"
                class="form-input"
                placeholder="e.g. BuyHive Ltd."
                v-model="formData.company_name"
              />
              <div class="input-error --end">
              </div>
             <div class="input-error --end">
              <span v-if="errors[0]">This field is required</span>
            </div>
            </ValidationProvider>
          </div>
          <div class="lg:pl-5 w-full lg:w-1/2">
            <div class="lg:pb-1 font-semibold text-lg lg:text-xl">
              Email <span class="lg:text-lg font-normal">(Username)</span>
              <span class="text-red-600">*</span>
            </div>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|email"
            >
              <input
                class="form-input"
                type="text"
                placeholder="e.g. john@email.com"
                name="Email"
                v-model="formData.email"
              >
              <div class="input-error --end">
                <span v-if="errors[0]">This field is required</span>
              </div>
            </ValidationProvider>
          </div>     
        </div>
        <div class="flex flex-wrap w-full">
          <div class="lg:pr-5 w-full lg:w-1/2">
            <div class="lg:pb-1 font-semibold text-lg lg:text-xl">
              Website<span class="text-red-600">*</span>
            </div>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <input
                name="website"
                class="form-input"
                placeholder="e.g. www.website.com"
                v-model="formData.website"
              />
              <div class="input-error --end">
                <span v-if="errors[0]">This field is required</span>
              </div>
            </ValidationProvider>
           </div>
          <div class="lg:pl-5 w-full lg:w-1/2 flex flex-wrap pt-8">
            <div class="w-1/2 xl:w-45p lg:pr-7 leading-5 text-base">
              Can your Sourcing Expert 
              disclose your company 
              name and company website 
              to suppliers?
            </div>
            <div class="w-1/2 xl:w-55p pl-5 lg:pl-0">
              <label class="flex">
                <input
                  type="radio"
                  class="w-5 h-5 mr-2 radio-item"
                  value="1"
                  name="agree"
                  v-model="formData.can_disclose_contact_info"
                />
                <div class="text-sm lg:text-base" style="max-width: calc(100% - 1.75rem)">Yes, you can disclose</div>
              </label>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <label class="flex mt-4 lg:mt-7">
                  <input
                    type="radio"
                    class="w-5 h-5 mr-2 radio-item"
                    value="0"
                    name="agree"
                    v-model="formData.can_disclose_contact_info"
                  />
                  <div class="text-sm lg:text-base" style="max-width: calc(100% - 1.75rem)">No, I want to be anonymous</div>
                </label>
                <div class="input-error --end">
                  <span v-if="errors[0]">This selection is required</span>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="flex lg:justify-end justify-center pt-20 pb-8">
          <button 
            :disabled="isSavingCompanyData"
            :class="{'opacity-50': isSavingCompanyData}"
            class="bg-blue text-white rounded-full py-3 px-5 text-lg lg:text-xl font-semibold"
          >
            Save & Continue
          </button>
        </div>
      </div>
    </form>
    <div class="text-center not-ready-section pb-3 pt-6">
      Not ready to commit? Questions? Let’s talk <br class="md:hidden"/> about your needs!
      <br/>
    </div>
    <div class="flex justify-center items-center">

      <button @click="getBookACallUrl" class="bg-theme  text-white rounded-full py-2 px-5 text-lg lg:text-xl font-semibold">
        Book a Call
      </button>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "CompanyDetailsForm",
  props: {
    userData: {
      type: Object,
      default: null
    },
    editSourcingDetails: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.formData = { ...this.formData, ...this.userData }
  },
  data() {
    return {
      formData: {},
      isSavingCompanyData: false
    }
  },
  watch: {
    userData() {
      this.formData = { ...this.formData, ...this.userData }
    }
  },
  computed: {
    ...mapGetters([
      'getSourcingToken'
    ])
  },
  methods: {
    ...mapActions(['createNewSourcingRequest', 'updateClientInformation']),
    async onSubmit() {
      this.isSavingCompanyData = true
      this.$emit('updateSourcingForm', { companyData: this.formData })
      let response = null
      if (this.getSourcingToken != null) {
        response = await this.updateClientInformation({ ...this.formData, _method: 'PUT' }) 
      } else {
        response = await this.createNewSourcingRequest(this.formData)
      }
      if (response.result) this.$emit('proceedNext')
      this.isSavingCompanyData = false
    },
    getBookACallUrl() {
      window.open(process.env.VUE_APP_BOOK_A_CALL_URL,'_blank');      
    },
  }
  };
</script>

<style lang="scss" scoped>
.radio-item{
  -webkit-appearance:none;
  width:20px;
  height:20px;
  border:1px solid darkgray;
  border-radius:50%;
  outline:none;
  &:before {
    content:'';
    display:block;
    width:60%;
    height:60%;
    margin: 20% auto;    
    border-radius:50%;    
  }
  &:checked:before {
    background:#00B2C9;
  }
}
.not-ready-section {
  @screen md {
  font-size: 26px;
  line-height: 39px;
  font-weight: 700;
  }
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
}
</style>